import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Dropdown from 'react-bootstrap/Dropdown'
import {
  DropdownToggleBtn,
  StyledDropdownMenu,
  NotificationItemText,
} from './dropdown'
import { Typography } from '../styled'
import { useTheme } from '../../contexts/themeContext'
import BaseButton from '../buttons/BaseButton'

export default function LanguagesDropdown() {
  const { i18n } = useTranslation()
  const [menu, setMenu] = React.useState(false)
  const { theme } = useTheme()

  const locales = {
    en: 'English',
    ar: 'العربية',
    gr: 'Deutsch',
  }

  useEffect(() => {
    const dir = i18n.dir(i18n.language)
    document.documentElement.dir = dir
  }, [i18n, i18n.language])

  return (
    <Dropdown
      show={menu}
      onToggle={() => setMenu(!menu)}
      className="d-inline-block"
      align="end"
    >
      <DropdownToggleBtn
        width="70px"
        tag="button"
        color={theme.localeTextColor}
      >
        <Typography color={theme.localeTextColor}>
          {
            locales[
              Object.keys(locales).filter((locale) => locale === i18n.language)
            ]
          }
        </Typography>
      </DropdownToggleBtn>
      <StyledDropdownMenu>
        {Object.keys(locales).map((locale) => (
          <NotificationItemText>
            <BaseButton
              className="w-100 text-start"
              backgroundcolor="transparent"
              hoverbackgroundcolor="transparent"
              color={theme.headersMiniTitle}
              key={locale}
              type="button"
              onClick={() => i18n.changeLanguage(locale)}
            >
              {locales[locale]}
            </BaseButton>
          </NotificationItemText>
        ))}
      </StyledDropdownMenu>
    </Dropdown>
  )
}
